const userKey = "userKey";

const LocalStorageHelper = {
    getUser: function () {
        try {
            return JSON.parse(localStorage.getItem(userKey));
        } catch (ex) {
            return null;
        }
    },
    setUser: function (user) {
        // console.info("hsdv", user);
        localStorage.setItem(userKey, JSON.stringify(user));
    },
    removeUser: function () {
        localStorage.removeItem(userKey);
    },
    selectedStation: {
        key: "selectedStation",
        get: function () {
            try {
                return JSON.parse(localStorage.getItem(this.key));
            } catch (ex) {
                console.error(ex);
                return null;
            }
        },
        set: function (newValue) {
            localStorage.setItem(this.key, JSON.stringify(newValue));
        },
    },
    appliedFilters: {
        key: "appliedFilters",
        get: function () {
            try {
                return JSON.parse(localStorage.getItem(this.key))?.currentFilters;
            } catch (ex) {
                console.error(ex);
                return null;
            }
        },
        set: function (newValue) {
            let filters = {
                currentFilters: newValue,
            };

            localStorage.setItem(this.key, JSON.stringify(filters));
        },
    },
};

export default LocalStorageHelper;
